import { createStore } from 'vuex'
import ShopInfo from './modules/ShopInfo'

export default createStore({
  state: {
  },
  getters: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    shopInfo: ShopInfo
  }
})
